import { Dispatch } from "redux";
import { QualificationDetailSortEnum } from "../../../common/enums/QualificationDetailSortEnum";
import { TertiaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";
import { handleAchievedCertificatesSort } from "./handleAchievedCertificatesSort";

interface Props {
    sortAchievedCertificates: {
        sortName: string;
        isSorted: boolean;
    };
    dispatch: Dispatch;
}

export const getEmployeeTableColumns = (
    props: Props,
): TertiaryTableColumn[] => {
    const { sortAchievedCertificates, dispatch } = props;

    return [
        {
            value: "Naam",
            isSortable: true,
            isSorted:
                sortAchievedCertificates.sortName ===
                QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
            sortOnClick: handleAchievedCertificatesSort({
                sortAchievedCertificates: {
                    isSorted:
                        sortAchievedCertificates.sortName ===
                        QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
                    sortName: QualificationDetailSortEnum.EMPLOYEE_NAME,
                },
                dispatch,
            }),
        },
        {
            value: "Opleider",
            isSortable: true,
            isSorted:
                sortAchievedCertificates.sortName ===
                QualificationDetailSortEnum.EDUCATOR_NAME_DESC,
            sortOnClick: handleAchievedCertificatesSort({
                sortAchievedCertificates: {
                    isSorted:
                        sortAchievedCertificates.sortName ===
                        QualificationDetailSortEnum.EDUCATOR_NAME_DESC,
                    sortName: QualificationDetailSortEnum.EDUCATOR_NAME,
                },
                dispatch,
            }),
        },
        {
            value: "Datum behaald",
            isSortable: true,
            isSorted:
                sortAchievedCertificates.sortName ===
                QualificationDetailSortEnum.VALID_AT_DESC,
            sortOnClick: handleAchievedCertificatesSort({
                sortAchievedCertificates: {
                    isSorted:
                        sortAchievedCertificates.sortName ===
                        QualificationDetailSortEnum.VALID_AT_DESC,
                    sortName: QualificationDetailSortEnum.VALID_AT,
                },
                dispatch,
            }),
        },
        {
            value: "Vervalt op",
            isSortable: true,
            isSorted:
                sortAchievedCertificates.sortName ===
                QualificationDetailSortEnum.EXPIRES_AT_DESC,
            sortOnClick: handleAchievedCertificatesSort({
                sortAchievedCertificates: {
                    isSorted:
                        sortAchievedCertificates.sortName ===
                        QualificationDetailSortEnum.EXPIRES_AT_DESC,
                    sortName: QualificationDetailSortEnum.EXPIRES_AT,
                },
                dispatch,
            }),
        },
        { value: "Certificaat" },
    ];
};
